import httpService from "@/core/services/http.service.js";
import physicalEntityMapper from "@/core/services/helpers/physicalEntityMapper.js";

// action types
export const GET_PHYSICAL_ENTITIES = "getPhysicalEntities";

// mutations types
export const SET_PHYSICAL_ENTITIES = "setPhysicalEntities";
export const SET_PHYSICAL_META = "setPhysicalMeta";

const state = {
  physicalEntities: [],
  meta: {},
};

const getters = {
  allPhysicalEntities: (state) => state.physicalEntities,
  physicalEntitiesMeta: (state) => state.meta,
};

const actions = {
  [GET_PHYSICAL_ENTITIES](context, { pageNumber = 1, perPage = 10, search = '' }) {
    httpService
      .get(`/api/b2b/physical-entities?page=${pageNumber}&per_page=${perPage}&search=${search}`)
      .then((response) => {
        context.commit(SET_PHYSICAL_ENTITIES, response.data.data);
        context.commit(SET_PHYSICAL_META, response.data.meta);
      });
  },
};

const mutations = {
  [SET_PHYSICAL_ENTITIES](state, physicalEntities) {
    state.physicalEntities =
      physicalEntityMapper.mapPhysicalEntities(physicalEntities);
  },
  [SET_PHYSICAL_META](state, meta) {
    state.meta = meta;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
